import { httpService } from '../../../http-service/httpService';
import { AXIOS_TIMEOUT_ERROR_MESSAGE } from '../../../http-service/serviceConstants';
import {
  bulkActionTimeoutConfig,
  IS_BULK_ACTIONS_COMPLETED,
  SET_ATLEAST_ONE_IS_SELECTED,
  SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL,
  SET_BULK_ACTIONS_ALERT,
  SET_BULK_ACTIONS_ISSUBMITTING,
  SET_BULK_FOOTER_DATA,
  SET_BULK_FOOTER_SHOW,
  SET_CHECK_FOR_BULK_CHEKBOX,
  SET_DISABLE_FOR_BULK_SELECT_ALL,
  SET_INDETERMINATE_FOR_BULK_CHEKBOX,
  SET_SHOW_BULK_SELECT_CHEKBOX,
  SET_SUBMIT_FOR_BULK_SELECT_ALL,
  tabMapping,
  TIMEOUT_CANCELLATION,
} from '../types';
import {
  URL_ADD_REMOVE_FROM_SESSION_API,
  URL_BULK_CONSULT_API,
  URL_BULK_REASSIGN_API,
  URL_BULK_UPDATE_API,
  URL_SELECT_ALL_API,
  URL_TREE_SELECT_ALL_API,
} from '../urls';

export const setIsBulkActionEnabled = (state) => (dispatch) => {
  dispatch({
    type: SET_SHOW_BULK_SELECT_CHEKBOX,
    payload: state,
  });
};

export const setIsBulkActionsCompleted = (payload) => (dispatch) => {
  dispatch({
    type: IS_BULK_ACTIONS_COMPLETED,
    payload,
  });
};

export const setAlteastOneIsSelected = (state) => (dispatch) => {
  dispatch({ type: SET_ATLEAST_ONE_IS_SELECTED, payload: state });
};

export const setBulkActionBySelectAll = (state) => (dispatch) => {
  dispatch({
    type: SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL,
    payload: state,
  });
};

export const setBulkActionIsDisabled = (state) => (dispatch) => {
  dispatch({ type: SET_DISABLE_FOR_BULK_SELECT_ALL, payload: state });
};

export const setBulkActionAlert = (isAlert, alertText) => (dispatch) => {
  dispatch({ type: SET_BULK_ACTIONS_ALERT, payload: { isAlert, alertText } });
};

export const setIndeterminateForBulkAction = (status) => (dispatch) => {
  dispatch({
    type: SET_INDETERMINATE_FOR_BULK_CHEKBOX,
    payload: status,
  });
};

export const setBulkActionFooterData = (data) => (dispatch) => {
  dispatch({
    type: SET_BULK_FOOTER_DATA,
    payload: data,
  });
};

export const setCheckForBulkAction = (status) => (dispatch) => {
  dispatch({
    type: SET_CHECK_FOR_BULK_CHEKBOX,
    payload: status,
  });
};

export const setBulkFooterShow = (status) => (dispatch) => {
  dispatch({
    type: SET_BULK_FOOTER_SHOW,
    payload: status,
  });
};

export const selectAllBulkAction =
  (certkey, clear = false, isEOCampaign = false) =>
  async (dispatch, getState) => {
    const {
      core: { searchText },
      tabs: { tabData },
      viewControls: { groupByOptions },
    } = getState().certifications.details;

    // Get the active tab key
    const activeTabKey = tabData?.find((tab) => tab.isActive).key;
    const activeTab = tabMapping[activeTabKey] || 'all';
    const selectedGroupByValue = groupByOptions?.find(
      (option) => option.isChecked
    )?.value;

    let body;

    if (isEOCampaign) {
      body = {
        certkey,
        tab: activeTab,
        requestOrigin: 'UI',
        sSearch: `${searchText}`,
      };
    } else {
      body = {
        certkey,
        tab: activeTab,
        sSearch: `${searchText}`,
        requestOrigin: 'UI',
        group_by: selectedGroupByValue,
      };
    }

    if (clear) {
      body.clrAll = '1';
    }

    dispatch({ type: SET_DISABLE_FOR_BULK_SELECT_ALL, payload: true });
    dispatch({ type: SET_SUBMIT_FOR_BULK_SELECT_ALL, payload: true });

    try {
      const { data } = await httpService.post(
        URL_SELECT_ALL_API,
        body
        // axiosTimeoutConfig
      );

      dispatch({
        type: SET_BULK_FOOTER_DATA,
        payload: !clear ? data : null,
      });
    } catch (error) {
      if (error === AXIOS_TIMEOUT_ERROR_MESSAGE) {
        throw Error(error);
      }

      throw Error('Not able to perform this action.');
    } finally {
      dispatch({ type: SET_DISABLE_FOR_BULK_SELECT_ALL, payload: false });
      dispatch({ type: SET_SUBMIT_FOR_BULK_SELECT_ALL, payload: false });
    }
  };

export const individualBulkAction =
  (certkey, eid, checked, uniqueId = false) =>
  async (dispatch) => {
    const body = {
      certkey,
      eid,
      checked: checked ? '1' : '0',
      requestOrigin: 'UI',
    };

    if (uniqueId) {
      body.unique_id = uniqueId; // eslint-disable-line camelcase
    }

    try {
      const { data } = await httpService.post(
        URL_ADD_REMOVE_FROM_SESSION_API,
        body
        // axiosTimeoutConfig
      );

      dispatch({
        type: SET_BULK_FOOTER_DATA,
        payload: data,
      });

      return data;
    } catch (error) {
      if (error === AXIOS_TIMEOUT_ERROR_MESSAGE) {
        throw Error(error);
      }

      throw Error('Not able to perform this action.');
    }
  };

export const individualTreeBulkAction =
  (userAccountKeys, clear = false) =>
  async (dispatch, getState) => {
    const {
      core: { searchText },
      global: { certKey },
      tabs: { tabData },
      viewControls: { groupByOptions },
    } = getState().certifications.details;

    // Get the active tab key
    const activeTabKey = tabData?.find((tab) => tab.isActive).key;
    const activeTab = tabMapping[activeTabKey] || 'all';
    const selectedGroupByValue = groupByOptions?.find(
      (option) => option.isChecked
    )?.value;

    const body = {
      certkey: certKey,
      tab: activeTab,
      requestOrigin: 'UI',
      sSearch: `${searchText}`,
      group_by: selectedGroupByValue,
      ...userAccountKeys,
    };

    if (clear) {
      body.clrAll = '1';
    }

    try {
      const { data } = await httpService.post(
        URL_TREE_SELECT_ALL_API,
        body
        // axiosTimeoutConfig
      );

      dispatch({
        type: SET_BULK_FOOTER_DATA,
        payload: data,
      });

      return data;
    } catch (error) {
      if (error === AXIOS_TIMEOUT_ERROR_MESSAGE) {
        throw Error(error);
      }

      throw Error('Not able to perform this action.');
    }
  };

export const bulkActionUpdateApi =
  (certkey, status, comments, payload, isEOCampaign = false) =>
  async (dispatch, getState) => {
    const body = {
      certkey,
      status,
      comments,
      bulkOperation: '1',
      ...(isEOCampaign ? { parentAction: '1' } : {}),
      ...payload,
    };

    if (isEOCampaign) {
      delete body.userAction;
    }

    const { bulkAction } = getState().certifications.details;

    if (!bulkAction?.isSubmittingAction) {
      dispatch({
        type: SET_BULK_ACTIONS_ISSUBMITTING,
        payload: true,
      });
    }

    try {
      const { data } = await httpService.post(
        URL_BULK_UPDATE_API,
        body,
        bulkActionTimeoutConfig
      );

      return data;
    } catch (error) {
      if (error === TIMEOUT_CANCELLATION) {
        // Add warning message
        throw error;
      }

      if (error === AXIOS_TIMEOUT_ERROR_MESSAGE) {
        throw Error(error);
      }

      throw bulkAction?.bulkFooterInfo;
    } finally {
      dispatch({
        type: SET_BULK_ACTIONS_ISSUBMITTING,
        payload: false,
      });
    }
  };

export const bulkActionConsultApi =
  (certkey, assignee, comments, reassignAssociated) =>
  async (dispatch, getState) => {
    const body = {
      certkey,
      assignee,
      bulkOperation: '1',
      comments,
      reassignAssociated,
    };

    const { bulkAction } = getState().certifications.details;

    if (!bulkAction?.isSubmittingAction) {
      dispatch({
        type: SET_BULK_ACTIONS_ISSUBMITTING,
        payload: true,
      });
    }

    try {
      const { data } = await httpService.post(
        URL_BULK_CONSULT_API,
        body,
        bulkActionTimeoutConfig
      );

      return data;
    } catch (error) {
      if (error === TIMEOUT_CANCELLATION) {
        // Add warning message
        throw error;
      }

      if (error === AXIOS_TIMEOUT_ERROR_MESSAGE) {
        throw Error(error);
      }

      throw bulkAction?.bulkFooterInfo;
    } finally {
      dispatch({
        type: SET_BULK_ACTIONS_ISSUBMITTING,
        payload: false,
      });
    }
  };

export const bulkActionReassignApi =
  (
    certkey,
    assignee,
    comments,
    controllerToPoint,
    payload,
    isEOCampaign = false
  ) =>
  async (dispatch, getState) => {
    const {
      bulkAction,
      global: { campaignKey },
    } = getState().certifications.details;
    const { reassignConfigMap } = getState().certifications.details.lineActions;
    let body = {
      certkey,
      campaignkey: `${campaignKey}`,
      callFromBulk: 'yes',
      comments,
      requestOrigin: 'UI',
    };

    if (!isEOCampaign) {
      body = {
        ...body,
        ...payload,
      };
    }

    // check the condition while resolving EO campaign bulk
    // if (isEOCampaign && controllerToPoint !== 'bulkReassign') {

    if (isEOCampaign) {
      if (assignee.length > 0) {
        body.assignee = assignee;

        if (controllerToPoint === 'bulkReassign') {
          body.hasNewManagerSelected = 'yes';

          if (body.assignee === reassignConfigMap?.defaultReassignee) {
            body.useDefaultReassignee = '1';
          } else {
            body.useDefaultReassignee = '0';
          }

          body.enableReassignStep2 = '1';
        } else {
          body.hasNewEntitlementOwnerSelected = 'yes';
          body.parentAction = '1';
          delete body.campaignkey;
          delete body.requestOrigin;
        }
      } else if (controllerToPoint !== 'bulkReassign') {
        body.parentAction = '1';
      }
    } else if (assignee.length > 0) {
      body.assignee = assignee;
      body.hasNewManagerSelected = 'yes';

      if (body?.assignee === reassignConfigMap?.defaultReassignee) {
        body.useDefaultReassignee = '1';
      } else {
        body.useDefaultReassignee = '0';
      }
    }

    if (!bulkAction?.isSubmittingAction) {
      dispatch({
        type: SET_BULK_ACTIONS_ISSUBMITTING,
        payload: true,
      });
    }

    try {
      const { data } = await httpService.post(
        `${URL_BULK_REASSIGN_API}/${controllerToPoint}`,
        body,
        bulkActionTimeoutConfig
      );
      const { msg } = data;

      if (msg === null) {
        throw Error('Coming null values as resposne //WIP');
      }

      return data;
    } catch (error) {
      if (
        error?.status === 409 &&
        error?.response?.data?.response &&
        typeof error?.response?.data?.response === 'string'
      ) {
        throw new Error(error.response.data.response);
      }

      if (error === TIMEOUT_CANCELLATION) {
        // Add warning message
        throw error;
      }

      if (error === AXIOS_TIMEOUT_ERROR_MESSAGE) {
        throw Error(error);
      }

      throw bulkAction?.bulkFooterInfo;
    } finally {
      dispatch({
        type: SET_BULK_ACTIONS_ISSUBMITTING,
        payload: false,
      });
    }
  };
